export enum VISIT_END_FIELDS {
	INTERVENTION_NUMBER = 'interventionNumber',
	COMMENT = 'comment',
}